/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySentryIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-sentry" */ './utils').then((m) => m.SentryIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/sentry/icon' },
);

const LazySentrySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-sentry-search-result" */ './utils').then(
			(m) => m.SentrySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const SentryIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySentryIconComponent />
	</Suspense>
);

export const SentrySearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySentrySearchResultIconComponent />
	</Suspense>
);
